import Vue from "vue";
import { mapActions, mapGetters } from "vuex";

/* eslint-disable no-unused-vars */
import coinComponent from "./coin-component";
import notificationComponent from "./notifications/notification-component";
import raffleComponent from "./raffle-component";
import startComponent from "./start-component";
/* eslint-enable no-unused-vars */

import { NOTIFICATIONS } from "../helpers";

Vue.component("game-component", {
  data() {
    return {
      showNotification: false,
      notificationData: {},

    };
  },
  template: `<div class="c-body l-locked" ><div>
              <div class="c-game"> 
                <div v-if="isPromoAvailable">
                  <!--<raffle-component v-on:notify="notify"></raffle-component>-->
                  <coin-component v-on:notify="notify"></coin-component>
                </div>
                <div v-if="!isPromoAvailable">
                  <start-component></start-component>
                </div>
              </div>
              <notification-component
                v-if="showNotification"
                v-bind:notificationData="notificationData"
                v-on:close="closeNotification"></notification-component>
            </div></div>`,
  methods: {
    ...mapActions([
      "setWinLose",
      "loadGame",
      "setRaffleModal",
      "loadAlreadyPlayedMessage",
      "loadRealMoneyPlayerdMessage"
    ]),
    buildNotification(nType, content = null) {
      const notification = content || this.notificationMessages[nType];
      const displayDurataion = () => {
        let duration = null;
        if (nType === "correct") duration = NOTIFICATIONS.time("guess");
        if (nType === "welcome") duration = NOTIFICATIONS.time("welcome");
        return duration;
      };
      if (notification.messageTypeTracking === "WinnerMessage") {
        nType = "WinnerMessage";
      }
      this.notificationData = {
        content: notification.message,
        showGames: notification.show_games,
        title: notification.title || null,
        type: nType,
        stayOpen: nType !== "correct",
        closeButton: notification.allow_close !== 0,
        action: notification.cta_show !== 0 ? notification.action : null,
        footer: notification.footer || null,
        duration: displayDurataion()
      };
      this.showNotification = true;
    },
    closeNotification() {
      this.notificationData = {};
      this.showNotification = false;
    },
    notify(nType) {
      const bonusMessage = notificationData => {
        this.buildNotification(nType, notificationData);
      };

      if (nType === "black") {
        this.setWinLose("0").then(notificationMessage =>
          bonusMessage(notificationMessage)
        );
      } else if (nType === "yellow") {
        this.setWinLose("1").then(notificationMessage =>
          bonusMessage(notificationMessage)
        );
      } else if (nType === "raffle") {
        this.setRaffleModal().then(notificationMessage =>
          bonusMessage(notificationMessage)
        );
      } else {
        this.buildNotification(nType);
      }
    }
  },
  computed: {
    ...mapGetters({
      alreadyPlayed: "getAlreadyPlayed",
      isPromoAvailable: "isPromoAvailable",
      labels: "getLabels",
      isLoggedIn: "isLoggedIn",
      notificationMessages: "notificationMessages",
      loading: "isLoading",
      isPMP: "getPMP"
    })
  },
  mounted() {

    const loaders = [this.isPromoAvailable ? this.loadGame() : false];

    Promise.all(loaders).then(() => {
      if (this.isPromoAvailable) {
        if (this.alreadyPlayed) {
          this.loadAlreadyPlayedMessage().then(notificationMessage =>
            this.buildNotification("TryAgainTomorrow", notificationMessage)
          );
        } else if (!this.isPMP) {
          this.loadRealMoneyPlayerdMessage().then(notificationMessage =>
            this.buildNotification("PlayMoneyPlayer", notificationMessage)
          );
        }
      } else {
        dataLayer.push({
          event: "Event.Functionality.",
          "page.referringAction": "coin-flip_LoginNeeded_Shown"
        });
      }
    });
  }
});



// WEBPACK FOOTER //
// ./app/js/components/game-component.js